const config = {
    env: import.meta.env.VITE_ENV || 'local',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  };

  export default config;
